module.exports = __webpack_public_path__ + "daad49ef66bffd252aedfad9b16b9078.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1156
// module chunks = 0